import React from 'react';
import { isStaging } from '../../lib/auth';

const Production = ({ children }) => {
    if (isStaging()) return null;

    return (
        <div>
            {children}
        </div>
    );
};

export default Production;